<template>
    <div class="learn-train-course">
        <div class="title">
            <img src="~assets/images/learn/titleImg.png" alt="" />
            <span>精品培训班</span>
        </div>
        <div class="course-list" v-if="hasTrains">
            <div
                v-for="(item, index) in trainList"
                :key="item.id"
                class="course-item"
            >
                <div class="course-item">
                    <img
                        src="~assets/images/learn/courseImg1.png"
                        alt=""
                        v-if="index % 2 == 0"
                    />
                    <img
                        src="~assets/images/learn/courseImg2.png"
                        alt=""
                        v-else
                    />
                    <div class="course-content">
                        <p>
                            {{ item.name }}
                        </p>
                        <div>
                            <span>授课形式：</span>
                            <span>线上授课</span>
                            <span class="ml20">价格：</span>
                            <span class="salePrice"
                                >￥{{ item.salePrice }}</span
                            >
                        </div>
                        <div>
                            <span>开课时间：</span>
                            <em>{{ item.startTime }}</em>
                            <span class="mlr10">至</span>
                            <em>{{ item.endTime }}</em>
                        </div>
                        <h6 @click="enterCourseDetails(item.id)">进入培训班</h6>
                    </div>
                </div>
            </div>
            <div class="block page_box" style="margin: 20px auto 0;">
                <el-pagination
                    layout="prev, pager, next"
                    :page-size="trainPageObj.size"
                    :background="true"
                    :total="trainPageObj.total"
                    @current-change="noticeCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
        <!-- <div class="noMore mtop20">~暂无更多课程~</div> -->
    </div>
</template>

<script>
import { getTrainSingup } from "api/train";
export default {
    computed: {
        // salePrice(){
        //     return function(price){
        //         let sPrice = price.substring(0,price.length-3);
        //         return sPrice
        //     }
        // }
    },
    data() {
        return {
            //是否有培训班
            hasTrains: false,
            //培训班分页器
            trainPageObj: {
                page: 1,
                size: 10,
                total: 0,
            },
            //培训班集合
            trainList: [],
        };
    },
    created() {
        this.fetchTrains(this.trainPageObj.page, this.trainPageObj.size);
    },
    methods: {
        noticeCurrentChange(current) {
            //分页数切换
            this.trainPageObj.page = current;
            this.fetchTrains(
                this.trainPageObj.page,
                this.trainPageObj.size
            );
        },
        fetchTrains(page, size) {
            getTrainSingup(page, size).then((res) => {
                let { success, errorCode, body } = res;
                let { count, list } = body.data;
                if (success && errorCode == "2000") {
                    this.trainPageObj.total = count;
                    this.trainList = list;
                    this.hasTrains = true;
                }
            });
        },
        //进入教育培训精品课程详情
        enterCourseDetails(trainId){
            this.$router.push({
                path:'/pcViews/learn/train-details',
                query:{
                    trainId
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
.ml20 {
    margin-left: 20px;
}
.mlr10 {
    margin: 0 10px;
}
.mln20 {
    margin-left: -20px;
}
.mrn20 {
    margin-right: -20px;
}
.noMore {
    text-align: center;
    font-size: 12px;
    color: #bdbfc9;
}
.salePrice {
    color: #ff8d1b;
    font-weight: bold;
}
.course-item {
    height: 272px;
    width: 583px;
    position: relative;
    > img {
        position: absolute;
        left: 0;
        top: 0;
    }
    > .course-content {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
        width: 100%;
        height: 100%;
        padding: 0 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-family: "微软雅黑";
        > p {
            width: 56%;
            font-size: 18px;
            line-height: 24px;
            font-weight: bold;
            color: #000000;
            margin-bottom: 8px;
        }
        > div {
            line-height: 18px;
            font-size: 12px;
            color: #535353;
            em {
                font-style: normal;
                text-decoration: underline;
            }
        }
        > h6 {
            margin-top: 18px;
            background-color: rgb(255, 170, 21);
            box-shadow: 0px 0px 6px 1px rgba(255, 208, 21, 0.5);
            width: 166px;
            height: 36px;
            border-radius: 18px;
            font-size: 14px;
            font-weight: bold;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
    }
}
.course-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.learn-train-course {
    width: 1166px;
    margin: 40px auto;
    .title {
        display: flex;
        flex-direction: row;
        height: 18px;
        font-size: 16px;
        font-weight: bold;
        font-family: "微软雅黑";
        color: #010101;
        > img {
            margin-right: 3px;
        }
    }
}
</style>
